import api from '@/lib/api';
import type { MatchingSearchResponse } from '../types/matching.types';

/**
 * Service API pour le matching IA
 */
export const matchingService = {
  /**
   * Lance une recherche de matching IA
   */
  async search(
    rawInput: string,
    locationMode?: string,
    budgetTolerance?: string,
    candidateIds?: number[],
  ): Promise<MatchingSearchResponse> {
    const response = await api.post<MatchingSearchResponse>('/itc/matching/search', {
      rawInput,
      locationMode,
      budgetTolerance,
      candidateIds: candidateIds && candidateIds.length > 0 ? candidateIds : undefined,
    });
    return response.data;
  },
};
